import { useEffect, useMemo, useState } from 'react';
import { ILogisticServiceHistory, TLogisticServiceStatusName } from '../../../../../types/suscription/history.types';
import { IHistorySL } from '../../../../../types/services';
import { IIncidentHistoryEvent } from '../../../../../types/incidents.types';
import { getIncidentsHistory } from '../../../../../services/incidents.service';
import {
  LOGISTIC_SERVICE_HISTORY_BASE_EVENTS,
  TLogisticServiceDates
} from '../../../../../constants/history.constants';
import { displayErrorNotification } from '../../../../../utils/displayNudosStandardNotifications';
import { LogisticServiceHistoryStepper } from './components/LogisticServiceHistoryStepper';
import { injectIncidentEventsIntoHistory } from './utils/incidentHistory.utils';

import './LogisticServiceDetailsTab4History.scss';

interface ILogisticServiceDetailsTab4HistoryProps {
  logisticServiceId?: number | null;
  logisticServiceHistoryData: ILogisticServiceHistory[];
  logisticServiceStatusName: TLogisticServiceStatusName;
  logisticServiceHistorySL?: IHistorySL[];
}

const LogisticServiceDetailsTab4History = ({
  logisticServiceId,
  logisticServiceHistoryData,
  logisticServiceStatusName,
  logisticServiceHistorySL
}: ILogisticServiceDetailsTab4HistoryProps) => {
  const [incidentEvents, setIncidentEvents] = useState<IIncidentHistoryEvent[]>([]);

  const transitionDates = useMemo(() => {
    if (!logisticServiceHistorySL?.length) return undefined;
    const dates = logisticServiceHistorySL.reduce<Record<string, string>>((acc, entry) => {
      const baseEvent = LOGISTIC_SERVICE_HISTORY_BASE_EVENTS[entry.status as TLogisticServiceDates];
      if (baseEvent?.statusName && entry.date) {
        acc[baseEvent.statusName] = entry.date;
      }
      return acc;
    }, {});
    return Object.keys(dates).length > 0 ? dates : undefined;
  }, [logisticServiceHistorySL]);

  const combinedHistory = useMemo(
    () => injectIncidentEventsIntoHistory(logisticServiceHistoryData, incidentEvents, transitionDates),
    [logisticServiceHistoryData, incidentEvents, transitionDates]
  );

  const renderSteps = () => {
    if (!combinedHistory?.length) {
      return <p className="emptyStateText">No hay historial disponible para este servicio logístico</p>;
    }

    return (
      <LogisticServiceHistoryStepper
        logisticServiceHistory={combinedHistory}
        logisticServiceStatusName={logisticServiceStatusName}
      />
    );
  };

  const fetchIncidentEvents = async (isActive: boolean, logisticServiceId: number) => {
    try {
      const events = await getIncidentsHistory(logisticServiceId);
      if (!events) throw new Error('No se pudo obtener el historial de incidentes');
      if (isActive) setIncidentEvents(events);
    } catch {
      if (isActive) setIncidentEvents([]);
    }
  };

  useEffect(() => {
    if (!logisticServiceId) return;
    let isActive = true;

    void fetchIncidentEvents(isActive, logisticServiceId);

    return () => {
      isActive = false;
    };
  }, [logisticServiceId]);

  return (
    <div className="logisticServiceDetailsTab4History">
      <h2 className="title">Historial del servicio</h2>
      <div className="boxDetails">{renderSteps()}</div>
    </div>
  );
};

export default LogisticServiceDetailsTab4History;
